import { render } from "./TwoColumn.vue?vue&type=template&id=5b2cc519"
import script from "./TwoColumn.vue?vue&type=script&lang=js"
export * from "./TwoColumn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TwoColumn.vue?vue&type=style&index=0&id=5b2cc519&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__